<template>
    <article class="fixed w-64 bg-white border-l border-gray-3 border-solid shadow-2l" :class="{ 'is-open': isVisible }">
        <header class="flex justify-between items-center border-b border-gray-3 border-solid">
            <div class="flex flex-col items-start">
                <div class="flex items-center" style="padding: 5px 14px;">
                    <ul>
                        <li class="c-nav__menuitem" v-if="is_staff == 'true'">
                            <a href="javascript:void(0)"
                                        class="flex py-4 px-6 text-gray-1 hover:text-green-normal"
                                        @click="openSwitch()">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    height="24"
                                    width="24" class="fill-current">
                                    <use v-bind="{'xlink:href': '#c-icon-switch'}"></use>
                                </svg>
                                <span class="ml-3">Switch Account</span>
                            </a>
                        </li>
                        <li class="c-nav__menuitem" @click="$root.$emit('closeOtherModals2')">
                            <router-link to="/profile"
                                        class="flex py-4 px-6 text-gray-1 hover:text-green-normal">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    height="24"
                                    width="24" class="fill-current">
                                    <use v-bind="{'xlink:href': '#c-icon-profile'}"></use>
                                </svg>
                                <span class="ml-3">Profile</span>
                            </router-link>
                        </li>
                        <li class="c-nav__menuitem">
                            <a href="javascript:void(0)"
                                        class="flex py-4 px-6 text-gray-1 hover:text-green-normal"
                                        @click="logout()">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    height="24"
                                    width="24" class="fill-current">
                                    <use v-bind="{'xlink:href': '#c-icon-logout'}"></use>
                                </svg>
                                <span class="ml-3">Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <Button class="w-24 bg-gray-2 text-black-3 hover:bg-gray-3 hover:text-black-2"
                    rounded
                    @click.native="clearNotifications">
                Clear
            </Button> -->
        </header>
        <!-- <ul v-if="notifications.length > 0">
            <li v-for="(notification, index) in notifications" :key="index" class="border-b border-gray-3 border-solid">
                <Notification class="cursor-pointer" :type="notification.type"
                              :content="notification.content"
                              :time="notification.time" />
            </li>
        </ul> -->
    </article>
</template>

<script>
    // import Button from "./Button";
    // import Notification from "./Notification";
    import router from "../router";

    export default {
        name: "SideBar",
        components: {
        },
        props: {
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                is_staff: localStorage.getItem("is_staff")
            }
        },
        methods: {
            clearNotifications () {
                this.notifications = [];
            },
            logout(){
                localStorage.removeItem("token");
                localStorage.removeItem("on_business_name");
                localStorage.clear();
                router.push("/login");
            },
            openSwitch(){
                this.$root.$emit('closeOtherModals');
            }
        }
    }
</script>

<style scoped>
    article {
        top: 80px;
        right: -18rem;
        opacity: 0;
        transition: transform .25s cubic-bezier(0.4,0.0,0.2,1),
                    opacity .30s linear;
    }
    article.is-open {
        transform: translateX(-18rem);
        opacity: 1;
    }
</style>